import React from 'react'
import styled from 'styled-components'
import { DatePicker, SelectDropdown } from '@giphy/react-giphy-brand'
import { giphyCharcoal } from '@giphy/js-brand'

type CalendarIconProps = {
    active: boolean
}

const CalendarIcon = styled.i<CalendarIconProps>`
    margin-right: -10px;
    margin-left: -10px;
    font-size: 20px;
    color: ${props => (props.active ? 'white' : 'inherit')};
`

const Protip = styled.div`
    font-size: 12px;
    margin-left: 12px;
    text-align: left;
    line-height: 1.5em;
    border-top: 1px solid ${giphyCharcoal};
    padding-top: 5px;
    strong {
        font-weight: bold;
    }
`

const Container = styled.div``

type Props = {
    onDateUpdate: (start: string | Date, end: string | Date) => void
    active: boolean
}

const DateRangeFilter = ({ active, onDateUpdate = () => {} }: Props) => (
    <Container>
        <SelectDropdown theme={'icon'} label={<CalendarIcon active={active} className="ss-calendar" />}>
            <DatePicker defaultRange={[new Date(), new Date()]} onUpdate={onDateUpdate}></DatePicker>
            <Protip>
                <strong>Protip:</strong> Hold the shift key and click to select a date range!
            </Protip>
        </SelectDropdown>
    </Container>
)

export default DateRangeFilter
